<div class="research__container">
  <section><app-hero [title]="'Recherche clinique'" [icon]="'hero-research'"></app-hero></section>

  <section class="study__container">
    <p>
      La prise en charge des patients présentant des troubles cognitifs repose sur des outils et des
      méthodes en constante évolution. Malgré les avancées scientifiques, certaines situations
      cliniques peuvent encore bénéficier d’améliorations, notamment en matière de diagnostic
      précoce et de personnalisation des soins.
    </p>
    <p>
      Cela concerne à la fois l’évaluation neuropsychologique, où un diagnostic précis et
      suffisamment précoce n’est pas toujours possible, et les prises en charge rééducatives, pour
      lesquelles les approches peuvent encore être optimisées selon les profils des patients.
    </p>
    <p>
      Dans ce contexte, nos centres s’inscrivent dans une démarche de recherche clinique en
      collaboration avec des hôpitaux et des universités à l’échelle nationale. Ces protocoles de
      recherche permettent d’améliorer les connaissances en neuropsychologie et de proposer aux
      patients des évaluations et des prises en charge fondées sur les données scientifiques les
      plus récentes, lorsque cela est pertinent.
    </p>
    <h2>Etudes en cours</h2>
    <div class="studies__list">
      <div class="study__item">
        <div><span>Etude :</span> COGEVOL</div>
        <div><span>Partenaire(s) : </span> SSA, ENS Paris Saclay</div>
        <div>
          <span>Objectif(s) : </span> Améliorer le diagnositc et le suivi des patients traumatisés
          crâniens
        </div>
        <div>
          <span>Sujets : </span> Patients traumatisés crâniens, sujets sans pathologie cognitive, 18
          à 65 ans
        </div>
      </div>
      <div class="study__item">
        <div><span>Etude :</span> BIOCOGDIFF</div>
        <div><span>Partenaire(s) : </span> Université Paris Cité</div>
        <div>
          <span>Objectif(s) : </span> Améliorer le diagnositc des pathologies neurologiques et
          psychiatriques
        </div>
        <div>
          <span>Sujets : </span> Patients traumatisés crâniens, DLC, ACP, Schizophrénie, sujets sans
          pathologie cognitive, 18 ans et plus
        </div>
      </div>
    </div>
    <div class="volontary">
      <span [style.color]="'#22b0dd'">Volontaire pour participer à une recherche ?</span> Vous êtes
      un proche ? Un patient ? Parlez en à votre professionnel CESCOG !
    </div>
    <div class="buttons">
      <a routerLink="/" class="btn btn-primary-outline">Retour</a>
    </div>
  </section>
</div>
